import React, { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [newUser, setNewUser] = useState({
    email: '',
    password: 'password123',
    full_name: '',
    role: 'user',
    status: 'active',
    manager_id: ''
  });

  useEffect(() => {
    fetchUsers();
    fetchManagers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .order("created_at", { ascending: false });
      
      if (error) throw error;
      setUsers(data || []);
    } catch (error) {
      console.error("Erreur chargement utilisateurs:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchManagers = async () => {
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('id, email, full_name, role')
        .in('role', ['admin', 'super_admin', 'manager'])
        .order('full_name');
      
      if (error) throw error;
      setManagers(data || []);
    } catch (error) {
      console.error('Erreur chargement managers:', error);
    }
  };

  const handleCreateUser = async (userData) => {
    try {
      const serviceRoleKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZyZWd2dGl1c2d3bXBvZGx2Z2ZuIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc3MDE2MTg4MywiZXhwIjoyMDg1NzM3ODgzfQ.pq7gEvv7LQMdPE0p1lXijf8QRrBx6WmrZB78gOG5kRU";
      const supabaseUrl = "https://fregvtiusgwmpodlvgfn.supabase.co";

      const response = await fetch(`${supabaseUrl}/auth/v1/admin/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': serviceRoleKey,
          'Authorization': `Bearer ${serviceRoleKey}`
        },
        body: JSON.stringify({
          email: userData.email,
          password: userData.password || "password123",
          email_confirm: true,
          user_metadata: {
            full_name: userData.full_name || userData.email,
            role: userData.role || "user"
          }
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.msg || "Erreur création utilisateur");
      }

      const authData = await response.json();

      await supabase
        .from("profiles")
        .delete()
        .eq("id", authData.id);

      const { error } = await supabase
        .from("profiles")
        .insert([{
          id: authData.id,
          email: userData.email,
          full_name: userData.full_name || userData.email,
          role: userData.role || "user",
          status: userData.status || "active",
          manager_id: userData.manager_id || null,
          permissions: {
            admin: userData.role === "admin" || userData.role === "super_admin",
            stock: true,
            billing: userData.role !== "agent",
            calendar: true,
            pipeline: userData.role === "admin" || userData.role === "manager",
            projects: userData.role === "admin" || userData.role === "super_admin"
          }
        }]);
      
      if (error) throw error;
      
      await fetchUsers();
      resetForm();
      alert(`Utilisateur ${userData.email} créé avec succès!`);
      
    } catch (error) {
      console.error("Erreur création utilisateur:", error);
      alert("Erreur: " + error.message);
    }
  };

  const handleUpdateUser = async (userId, updates) => {
    try {
      const { error } = await supabase
        .from("profiles")
        .update({
          full_name: updates.full_name,
          role: updates.role,
          status: updates.status,
          manager_id: updates.manager_id,
          updated_at: new Date()
        })
        .eq("id", userId);
      
      if (error) throw error;
      
      await fetchUsers();
      setEditingUser(null);
      resetForm();
      alert("Utilisateur mis à jour avec succès!");
    } catch (error) {
      console.error("Erreur mise à jour:", error);
      alert("Erreur: " + error.message);
    }
  };

  const handleDeleteUser = async (id) => {
    if (!confirm("Supprimer définitivement cet utilisateur ?")) return;
    
    try {
      const { error } = await supabase
        .from("profiles")
        .delete()
        .eq("id", id);
      
      if (error) throw error;
      
      await fetchUsers();
      alert("Utilisateur supprimé");
    } catch (error) {
      console.error("Erreur suppression:", error);
      alert("Erreur: " + error.message);
    }
  };

  const handleToggleStatus = async (user) => {
    const newStatus = user.status === "active" ? "inactive" : "active";
    await handleUpdateUser(user.id, { 
      full_name: user.full_name,
      role: user.role,
      status: newStatus,
      manager_id: user.manager_id
    });
  };

  const resetForm = () => {
    setShowForm(false);
    setEditingUser(null);
    setNewUser({
      email: "",
      password: "password123",
      full_name: "",
      role: "user",
      status: "active",
      manager_id: ""
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editingUser) {
      handleUpdateUser(editingUser.id, newUser);
    } else {
      handleCreateUser(newUser);
    }
  };

  const startEdit = (user) => {
    setEditingUser(user);
    setNewUser({
      email: user.email,
      password: "password123",
      full_name: user.full_name || "",
      role: user.role || "user",
      status: user.status || "active",
      manager_id: user.manager_id || ""
    });
    setShowForm(true);
  };

  const getRoleBadgeStyle = (role) => {
    const styles = {
      super_admin: { bg: '#f3e8ff', color: '#6b21a8', text: 'Super Admin' },
      admin: { bg: '#fee2e2', color: '#991b1b', text: 'Admin' },
      manager: { bg: '#dbeafe', color: '#1e40af', text: 'Manager' },
      agent: { bg: '#dcfce7', color: '#166534', text: 'Agent' },
      user: { bg: '#f3f4f6', color: '#1f2937', text: 'Utilisateur' },
      partner: { bg: '#fff3cd', color: '#856404', text: 'Partenaire' }
    };
    return styles[role] || styles.user;
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: '#f3f4f6',
        color: '#4b5563',
        fontSize: '1.125rem'
      }}>
        Chargement...
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f3f4f6',
      padding: '2rem'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem'
        }}>
          <h1 style={{
            fontSize: '1.875rem',
            fontWeight: 'bold',
            color: '#111827',
            margin: 0
          }}>
            Gestion des utilisateurs
          </h1>
          <button
            onClick={() => {
              resetForm();
              setShowForm(!showForm);
            }}
            style={{
              backgroundColor: showForm ? '#6b7280' : '#2563eb',
              color: 'white',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '0.5rem',
              fontSize: '0.875rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = showForm ? '#4b5563' : '#1d4ed8';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = showForm ? '#6b7280' : '#2563eb';
            }}
          >
            {showForm ? 'Annuler' : '+ Nouvel utilisateur'}
          </button>
        </div>

        {/* Formulaire de création/édition */}
        {showForm && (
          <div style={{
            backgroundColor: 'white',
            borderRadius: '0.5rem',
            padding: '1.5rem',
            marginBottom: '2rem',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}>
            <h2 style={{
              fontSize: '1.25rem',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '1.5rem'
            }}>
              {editingUser ? 'Modifier' : 'Créer'} un utilisateur
            </h2>
            
            <form onSubmit={handleSubmit}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '1rem',
                marginBottom: '1.5rem'
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Email *
                  </label>
                  <input
                    type="email"
                    value={newUser.email}
                    onChange={(e) => setNewUser({...newUser, email: e.target.value})}
                    disabled={editingUser}
                    style={{
                      width: '100%',
                      padding: '0.5rem 0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem',
                      fontSize: '0.875rem',
                      backgroundColor: editingUser ? '#f3f4f6' : 'white',
                      cursor: editingUser ? 'not-allowed' : 'text'
                    }}
                    required
                  />
                </div>
                
                {!editingUser && (
                  <div>
                    <label style={{
                      display: 'block',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      color: '#374151',
                      marginBottom: '0.5rem'
                    }}>
                      Mot de passe
                    </label>
                    <input
                      type="text"
                      value={newUser.password}
                      onChange={(e) => setNewUser({...newUser, password: e.target.value})}
                      style={{
                        width: '100%',
                        padding: '0.5rem 0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem',
                        fontSize: '0.875rem'
                      }}
                    />
                  </div>
                )}
                
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Nom complet
                  </label>
                  <input
                    type="text"
                    value={newUser.full_name}
                    onChange={(e) => setNewUser({...newUser, full_name: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '0.5rem 0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem',
                      fontSize: '0.875rem'
                    }}
                    placeholder="Jean Dupont"
                  />
                </div>
                
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Rôle
                  </label>
                  <select
                    value={newUser.role}
                    onChange={(e) => setNewUser({...newUser, role: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '0.5rem 0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem',
                      fontSize: '0.875rem',
                      backgroundColor: 'white'
                    }}
                  >
                    <option value="user">Utilisateur</option>
                    <option value="agent">Agent</option>
                    <option value="manager">Manager</option>
                    <option value="admin">Admin</option>
                    <option value="super_admin">Super Admin</option>
                    <option value="partner">Partenaire</option>
                  </select>
                </div>
                
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Statut
                  </label>
                  <select
                    value={newUser.status}
                    onChange={(e) => setNewUser({...newUser, status: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '0.5rem 0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem',
                      fontSize: '0.875rem',
                      backgroundColor: 'white'
                    }}
                  >
                    <option value="active">Actif</option>
                    <option value="inactive">Inactif</option>
                  </select>
                </div>
                
                <div>
                  <label style={{
                    display: 'block',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#374151',
                    marginBottom: '0.5rem'
                  }}>
                    Manager
                  </label>
                  <select
                    value={newUser.manager_id}
                    onChange={(e) => setNewUser({...newUser, manager_id: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '0.5rem 0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem',
                      fontSize: '0.875rem',
                      backgroundColor: 'white'
                    }}
                  >
                    <option value="">Aucun</option>
                    {managers.map(manager => (
                      <option key={manager.id} value={manager.id}>
                        {manager.full_name || manager.email} ({manager.role})
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div style={{
                display: 'flex',
                gap: '0.75rem'
              }}>
                <button
                  type="submit"
                  style={{
                    backgroundColor: '#059669',
                    color: 'white',
                    border: 'none',
                    padding: '0.625rem 1.25rem',
                    borderRadius: '0.375rem',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#047857'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#059669'}
                >
                  {editingUser ? 'Mettre à jour' : 'Créer'}
                </button>
                <button
                  type="button"
                  onClick={resetForm}
                  style={{
                    backgroundColor: '#6b7280',
                    color: 'white',
                    border: 'none',
                    padding: '0.625rem 1.25rem',
                    borderRadius: '0.375rem',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Tableau des utilisateurs */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          overflow: 'hidden',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <div style={{
            overflowX: 'auto'
          }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              minWidth: '1000px'
            }}>
              <thead>
                <tr style={{
                  backgroundColor: '#f9fafb',
                  borderBottom: '1px solid #e5e7eb'
                }}>
                  <th style={tableHeaderStyle}>Email</th>
                  <th style={tableHeaderStyle}>Nom</th>
                  <th style={tableHeaderStyle}>Rôle</th>
                  <th style={tableHeaderStyle}>Manager</th>
                  <th style={tableHeaderStyle}>Statut</th>
                  <th style={tableHeaderStyle}>Créé le</th>
                  <th style={tableHeaderStyle}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => {
                  const roleStyle = getRoleBadgeStyle(user.role);
                  const manager = managers.find(m => m.id === user.manager_id);
                  
                  return (
                    <tr key={user.id} style={{
                      borderBottom: '1px solid #e5e7eb',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <td style={tableCellStyle}>{user.email}</td>
                      <td style={tableCellStyle}>{user.full_name || '-'}</td>
                      <td style={tableCellStyle}>
                        <span style={{
                          display: 'inline-block',
                          padding: '0.25rem 0.75rem',
                          borderRadius: '9999px',
                          fontSize: '0.75rem',
                          fontWeight: '500',
                          backgroundColor: roleStyle.bg,
                          color: roleStyle.color
                        }}>
                          {roleStyle.text}
                        </span>
                      </td>
                      <td style={tableCellStyle}>
                        {manager ? manager.full_name || manager.email : '-'}
                      </td>
                      <td style={tableCellStyle}>
                        <span style={{
                          display: 'inline-block',
                          padding: '0.25rem 0.75rem',
                          borderRadius: '9999px',
                          fontSize: '0.75rem',
                          fontWeight: '500',
                          backgroundColor: user.status === 'active' ? '#dcfce7' : '#f3f4f6',
                          color: user.status === 'active' ? '#166534' : '#4b5563'
                        }}>
                          {user.status === 'active' ? 'Actif' : 'Inactif'}
                        </span>
                      </td>
                      <td style={tableCellStyle}>
                        {new Date(user.created_at).toLocaleDateString('fr-FR')}
                      </td>
                      <td style={{
                        ...tableCellStyle,
                        textAlign: 'right'
                      }}>
                        <div style={{
                          display: 'flex',
                          gap: '0.5rem',
                          justifyContent: 'flex-end'
                        }}>
                          <button
                            onClick={() => startEdit(user)}
                            style={actionButtonStyle}
                            onMouseEnter={(e) => e.target.style.color = '#1e40af'}
                            onMouseLeave={(e) => e.target.style.color = '#2563eb'}
                          >
                            Modifier
                          </button>
                          <button
                            onClick={() => handleToggleStatus(user)}
                            style={{
                              ...actionButtonStyle,
                              color: user.status === 'active' ? '#d97706' : '#059669'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.color = user.status === 'active' ? '#b45309' : '#047857';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.color = user.status === 'active' ? '#d97706' : '#059669';
                            }}
                          >
                            {user.status === 'active' ? 'Désactiver' : 'Activer'}
                          </button>
                          <button
                            onClick={() => handleDeleteUser(user.id)}
                            style={{
                              ...actionButtonStyle,
                              color: '#dc2626'
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#b91c1c'}
                            onMouseLeave={(e) => e.target.style.color = '#dc2626'}
                          >
                            Supprimer
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

// Styles communs
const tableHeaderStyle = {
  padding: '0.75rem 1rem',
  textAlign: 'left',
  fontSize: '0.75rem',
  fontWeight: '600',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: '#6b7280'
};

const tableCellStyle = {
  padding: '1rem',
  fontSize: '0.875rem',
  color: '#111827'
};

const actionButtonStyle = {
  background: 'none',
  border: 'none',
  fontSize: '0.875rem',
  fontWeight: '500',
  cursor: 'pointer',
  padding: '0.25rem 0.5rem',
  transition: 'color 0.2s'
};

export default UsersPage;
